/* 手机商品页「价格进首屏」两个候选版式(2026-10-31 老板「AB都做一版本给我预览」)。
   <html> 没有 pd-pricefirst-a / pd-pricefirst-b 就直接退出 → 对照组零改动。
   A = 品牌行 + 标题 + 价格 搬到图库上面(只在手机布局 ≤749px;转横屏/电脑宽度自动搬回)。
   B = 网站现有的底部悬浮条(sections/mobile-sticky-atc.liquid #StickyATCBar,原来只在滚过主加购按钮后出现)
       提前到一进页面就显示(主加购按钮还在视口下方时),并在条里加当前价格;主按钮在屏幕里时照旧收起,
       滚过主按钮后仍是原来的那条(多了价格)。加购、返回表单、聊天按钮让位都复用原有逻辑。
   两版都只搬/镜像主题现成的节点:价格块保留原 id(主题换规格仍按 id 更新)。 */
(function () {
  'use strict';
  var html = document.documentElement;
  var A = html.classList.contains('pd-pricefirst-a');
  var B = html.classList.contains('pd-pricefirst-b');
  if (!A && !B) return;
  var mq = window.matchMedia('(max-width: 749px)');
  function onMq(fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function section() { return document.querySelector('[id^="MainProduct-"]'); }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function priceTextOf(price) {
    var c = price.querySelector('.price'); var sale = !!(c && c.classList.contains('price--on-sale'));
    return txt(price.querySelector(sale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular')) || txt(price.querySelector('.price-item'));
  }

  function setupA() {
    var sec = section(); if (!sec) return;
    var media = sec.querySelector('.product__media-wrapper');
    var info = sec.querySelector('.product__info-container');
    if (!media || !info) return;
    var title = info.querySelector(':scope > .product__title');
    var price = info.querySelector(':scope > [id^="price-"]');
    if (!title || !price) return;
    var vendor = info.querySelector(':scope > .product__text');
    var picks = vendor ? [vendor, title, price] : [title, price];
    // 原位置留锚点,离开手机布局时原样搬回
    var anchors = picks.map(function (el) { var a = document.createComment('pd-pf-anchor'); el.parentNode.insertBefore(a, el); return a; });
    var head = document.createElement('div'); head.className = 'pd-pf-head';
    var on = false;
    function apply() {
      if (on) return; on = true;
      picks.forEach(function (el) { head.appendChild(el); });
      media.parentNode.insertBefore(head, media);
      html.classList.add('pd-pf-a-on');
    }
    function restore() {
      if (!on) return; on = false;
      picks.forEach(function (el, i) { anchors[i].parentNode.insertBefore(el, anchors[i]); });
      if (head.parentNode) head.parentNode.removeChild(head);
      html.classList.remove('pd-pf-a-on');
    }
    function sync() { if (mq.matches) apply(); else restore(); }
    sync(); onMq(sync);
  }

  function setupB() {
    var sec = section(); if (!sec) return;
    var bar = document.getElementById('StickyATCBar');
    var box = bar && bar.querySelector('.sticky-btn-container');
    var mainBtn = sec.querySelector('product-form button[name="add"]') || sec.querySelector('button[name="add"]');
    var price = sec.querySelector('[id^="price-"]');
    if (!bar || !box || !mainBtn || !price) return;
    // 条里加价格(镜像主价格块,换规格跟着变)
    var out = document.createElement('div'); out.className = 'pd-pf-price';
    box.insertBefore(out, box.firstChild);
    function syncPrice() { out.textContent = priceTextOf(price); }
    syncPrice();
    new MutationObserver(syncPrice).observe(price, { childList: true, subtree: true, characterData: true });
    // 主加购按钮还在视口下方 → 提前显示;按钮在屏幕里 → 收起;滚过按钮 → 原有 is-visible 逻辑接管
    var ticking = false;
    function check() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var r = mainBtn.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var early = mq.matches && r.top > vh;
        bar.classList.toggle('pd-pf-early', early);
        html.classList.toggle('pd-pf-early-on', early);
      });
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(check).observe(mainBtn);
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    onMq(check); check();
  }

  ready(function () { if (A) setupA(); if (B) setupB(); });
})();
